/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-unstable-nested-components */
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Joyride, { STATUS, EVENTS, ACTIONS } from 'react-joyride';
import styled from 'styled-components';
import { Space, Select, Popover, Tag, message, Button, notification } from 'antd';
import { updatePlanModal, updateNavigationTourGuide } from 'store/user';
import { DownOutlined, CaretDownOutlined, PlusOutlined } from '@ant-design/icons';
import FileSaver from 'file-saver';
// import SummaryCard from 'components/SummaryCard';
import EbzTable from 'components/EbzTable';
import EbzButton from 'components/EbzButton';
import EbzFilterGroup from 'components/EbzFilterGroup';
import { ExportIcon, NotitficationIcon } from 'utils/icons';
import leadsAPI from 'services/leads';
import merchantAPI from 'services/merchants';
import { leadPriority, leadStatus } from 'constants';
import { LEAD_PRIORITY, LEAD_STATUS } from 'constants/status';
import dayjs from 'dayjs';
import joyrideCustomTooltip from 'components/JoyrideComponent/JoyrideTooltip';
import trackingService from 'services/trackingService';
import Alert from 'components/Alert';
import EVENT_NAME from 'utils/const';
import { TOUR_LEAD_CONTENT } from './const';

const filtersArr = [
  {
    label: 'Lead Priority',
    attr: 'priority',
    data: leadPriority
  },
  {
    label: 'Lead Status',
    attr: 'status',
    data: leadStatus
  }
];

const searchArr = [
  {
    value: 'email',
    label: 'Email'
  },
  {
    value: 'business_name',
    label: 'Name of Business'
  }
];

const SelectWrapper = styled(Select)`
  .ant-select-selector {
    box-shadow: 0px 3px 6px #0000001a;
    border-radius: 6px;
    border: 0px !important;
  }
`;

function LeadsListPage() {
  // const [hasSummaryData, setHasSummaryData] = useState(false);
  // const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [data, setData] = useState({});
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: false,
      total: 0
    }
  });
  const [filtersObj, setFiltersObj] = useState({});
  const [tourGuideRun, setTourGuideRun] = useState(false);
  const [tourGuideSteps, setTourGuideSteps] = useState([]);
  const [tourStepIndex, setTourStepIndex] = useState(0);

  const [api, contextHolder] = notification.useNotification();

  // const planType = useSelector((state) => state.user.plan.plan_type);
  const isLeadAllowed = useSelector((state) => state.user?.planPermissions?.can_view_leads);
  const canCreateLead = useSelector((state) => state.user?.planPermissions?.can_create_lead);
  const canUpdateLead = useSelector((state) => state.user?.planPermissions?.can_update_lead);
  const canExportLead = useSelector((state) => state.user?.planPermissions?.can_export_lead);
  const planModal = useSelector((state) => state.user?.planModal);
  const tourGuide = useSelector((state) => state.user?.navigationTourGuidetails);
  const dispatch = useDispatch();
  const togglePlanModal = () => {
    dispatch(updatePlanModal(!planModal));
  };

  // react router
  const navigate = useNavigate();
  //

  // functions for api
  // const fetchLeadSummary = async (payload) => {
  //   const response = await leadsAPI.summary(payload);

  //   if (!response.success) {
  //     setHasSummaryData(false);
  //     console.log('something went wrong');
  //     // Alert('something went wrong', 'Please contact support team for this', 'error');
  //   }

  //   setSummary(response?.data ?? []);
  // };

  const fetchLeadsList = async (pagination, filters) => {
    setLoading(true);

    const response = await leadsAPI.list({
      current_page: pagination.current,
      total_counts: pagination.total,
      ...filters
    });

    if (!response.success) {
      console.log('something went wrong');
      // Alert('something went wrong', 'Please contact support team for this', 'error');
      setHasData(false);
    }

    setData(response?.data ?? []);
    setLoading(false);
    setTableParams({
      ...tableParams,
      pagination: {
        ...pagination,
        total: response?.data.total_counts
      }
    });
  };

  const leadDownloadableReport = async () => {
    if (data.leads.length > 0) {
      const response = await leadsAPI.downloadableReport({
        current_page: tableParams.pagination.current,
        ...filtersObj
      });

      const contentType = response.headers['content-type'];
      if (contentType && contentType.includes('application/json')) {
        Alert('something went wrong', 'Please contact support team for this', 'error');
      } else {
        api.open({
          message: 'CSV Export',
          description: 'Report has been generated.',
          icon: <NotitficationIcon />
        });

        FileSaver.saveAs(response.data, `lead_export.csv`);
      }
    } else {
      message.error({
        content: 'No records for CSV export'
      });
    }
  };
  //

  // functions
  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter
    });

    fetchLeadsList(pagination, filtersObj);
  };

  const applyFiltersCallbackfunc = (a) => {
    setLoading(true);

    const updatePagination = { ...tableParams.pagination };
    updatePagination.current = 1;
    updatePagination.total = 0;

    const [searchParams, checkboxGroup] = a;
    const filters = {
      ...searchParams,
      ...checkboxGroup
    };

    setFiltersObj(filters);

    fetchLeadsList(updatePagination, filters);
  };

  const clearFiltersCallBackfun = () => {
    setLoading(true);

    const updatePagination = { ...tableParams.pagination };
    updatePagination.current = 1;
    updatePagination.total = 0;
    setFiltersObj({});
    fetchLeadsList(updatePagination);
  };

  const handleChange = (value) => {
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, { name: value });
    navigate(`/${value}`);
  };

  const fetchAndUpdateNavigation = async (paramKey) => {
    const request = {
      update: paramKey
    };
    const response = await merchantAPI.fetchNavigationFlag(request);
    if (response.success) {
      dispatch(updateNavigationTourGuide(response?.data));
    } else {
      console.log('something went wrong');
    }
  };

  const handleJoyrideCallback = (callbackProps) => {
    const { status, index, type, action, size } = callbackProps;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      if ([ACTIONS.NEXT].includes(action)) {
        const nextIndex = index + 1;
        setTourStepIndex(nextIndex);
      } else {
        const prevIndex = index - 1;
        setTourStepIndex(prevIndex);
      }
      if (index === 1 && [ACTIONS.PREV].includes(action)) {
        setTourGuideRun(false);
        fetchAndUpdateNavigation('disable_lead_guide');
      }
    }
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Need to set our running state to false, so we can restart if we click start again.
      setTourGuideRun(false);
    }
    const lastStepIndex = size - index;
    if ([ACTIONS.CLOSE].includes(action) || [EVENTS.TOUR_END].includes(type)) {
      if (lastStepIndex > 1) {
        setTourStepIndex(size - 1);
      } else {
        setTourGuideRun(false);
        fetchAndUpdateNavigation('disable_lead_guide');
      }
    }
  };

  // effects
  useEffect(() => {
    // fetchLeadSummary();
    if (isLeadAllowed) {
      fetchLeadsList(tableParams.pagination);
    }
  }, []);

  useEffect(() => {
    if (isLeadAllowed) {
      fetchLeadsList(tableParams.pagination);
    }
  }, [isLeadAllowed]);

  useEffect(() => {
    if (Object.keys(data).length !== 0) {
      setHasData(true);
    }
  }, [data]);

  useEffect(() => {
    if (
      tourGuide?.dashboard_guide?.tour_guide &&
      tourGuide?.dashboard_guide?.dashboard_modules?.disable_lead_guide
    ) {
      setTourGuideRun(!tourGuideRun);
      setTourGuideSteps(TOUR_LEAD_CONTENT);
      setTourStepIndex(1);
    }
  }, [tourGuide]);

  // useEffect(() => {
  //   if (Object.keys(summary).length !== 0) {
  //     setHasSummaryData(true);
  //   }
  // }, [summary]);
  //

  const columns = [
    {
      title: <Space>Name of Business</Space>,
      dataIndex: 'name_of_business',
      key: 'name_of_business',
      ellipsis: {
        showTitle: false
      }
    },
    {
      title: 'Phone Number',
      dataIndex: 'phone_number',
      key: 'phone_number'
    },
    {
      title: 'Email',
      dataIndex: 'email_id',
      key: 'email_id',
      ellipsis: {
        showTitle: false
      }
    },
    {
      title: 'Date Created',
      dataIndex: 'document_created_at',
      key: 'document_created_at',
      ellipsis: {
        showTitle: false
      },
      render: (e) => {
        return e === null ? 'Invalid Date' : dayjs(e).format("DD MMM, 'YY");
      }
    },
    {
      title: (
        <Space>
          Lead Priority
          {/* <Tooltip placement="top" title="info">
          <InfoCircleOutlined style={{ color: '#A0A0A0' }} />
        </Tooltip> */}
        </Space>
      ),
      dataIndex: 'priority',
      key: 'priority',
      align: 'center',
      render: (e) => {
        return LEAD_PRIORITY[e] ? (
          <Tag
            color={LEAD_PRIORITY[e].bgColor}
            style={{ padding: '2px 13px', color: LEAD_PRIORITY[e].color, fontSize: '12px' }}
          >
            {LEAD_PRIORITY[e].label}
          </Tag>
        ) : (
          <Tag color="#EBEBEB" style={{ padding: '2px 13px', color: '#7B7B7B', fontSize: '12px' }}>
            {e}
          </Tag>
        );
      }
    },
    {
      title: (
        <Space>
          Status
          {/* <Tooltip placement="top" title="info">
          <InfoCircleOutlined style={{ color: '#A0A0A0' }} />
        </Tooltip> */}
        </Space>
      ),
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (e) => {
        return LEAD_STATUS[e] ? (
          <Tag
            color={LEAD_STATUS[e].bgColor}
            style={{ padding: '2px 13px', color: LEAD_STATUS[e].color, fontSize: '12px' }}
          >
            {LEAD_STATUS[e].label}
          </Tag>
        ) : (
          <Tag color="#EBEBEB" style={{ padding: '2px 13px', color: '#7B7B7B', fontSize: '12px' }}>
            {e}
          </Tag>
        );
      }
    },
    {
      title: <Space>Actions</Space>,
      align: 'center',
      render: (r) => {
        return (
          <SelectWrapper
            suffixIcon={<CaretDownOutlined style={{ fontSize: '15px', color: '#2A2A2A' }} />}
            style={{
              width: 100
            }}
            disabled={!canUpdateLead}
            defaultValue={[
              {
                value: 'Actions',
                label: 'Actions'
              }
            ]}
            options={[
              {
                value: `leads/update/${r._id}`,
                label: 'Edit'
              }
            ]}
            onChange={handleChange}
          />
        );
      }
    }
  ];

  return (
    <>
      <div
        style={{
          padding: '0 20px',
          margin: '20px 0px'
        }}
      >
        <Joyride
          callback={handleJoyrideCallback}
          continuous
          run={tourGuideRun}
          steps={tourGuideSteps}
          scrollOffset={64}
          showSkipButton
          styles={{
            options: {
              primaryColor: 'var(--color-fill-alter)',
              zIndex: 100
            }
          }}
          tooltipComponent={joyrideCustomTooltip}
          stepIndex={tourStepIndex}
        />
        {/* {hasSummaryData === true ? (
          <SummaryCard summary={summary} />
        ) : (
          <Row
            gutter={[8, 16]}
            style={{
              boxShadow: 'rgb(0 0 0 / 6%) 0px 3px 6px 4px',
              borderRadius: '10px',
              backgroundColor: 'white'
            }}
          >
            <Col
              span={6}
              style={{
                paddingTop: '10px',
                paddingBottom: '10px',
                paddingLeft: '10px',
                paddingRight: '10px',
                height: '100%',
                width: '100%',
                border: '4px solid',
                borderTop: '0',
                borderBottom: '0',
                borderLeft: '0',
                borderImage:
                  'linear-gradient(rgb(255, 255, 255) 10%, rgb(232, 232, 232) 48%, rgb(255, 255, 255) 90%) 1 / 1 / 0 stretch',
                borderImageSlice: '1'
              }}
            >
              <Skeleton
                active
                paragraph={{
                  rows: 2
                }}
              />
            </Col>
            <Col
              span={6}
              style={{
                paddingTop: '10px',
                paddingBottom: '10px',
                paddingLeft: '10px',
                paddingRight: '10px',
                height: '100%',
                width: '100%',
                border: '4px solid',
                borderTop: '0',
                borderBottom: '0',
                borderLeft: '0',
                borderImage:
                  'linear-gradient(rgb(255, 255, 255) 10%, rgb(232, 232, 232) 48%, rgb(255, 255, 255) 90%) 1 / 1 / 0 stretch',
                borderImageSlice: '1'
              }}
            >
              <Skeleton
                active
                paragraph={{
                  rows: 2
                }}
              />
            </Col>
            <Col
              span={6}
              style={{
                paddingTop: '10px',
                paddingBottom: '10px',
                paddingLeft: '10px',
                paddingRight: '10px',
                height: '100%',
                width: '100%',
                border: '4px solid',
                borderTop: '0',
                borderBottom: '0',
                borderLeft: '0',
                borderImage:
                  'linear-gradient(rgb(255, 255, 255) 10%, rgb(232, 232, 232) 48%, rgb(255, 255, 255) 90%) 1 / 1 / 0 stretch',
                borderImageSlice: '1'
              }}
            >
              <Skeleton
                active
                paragraph={{
                  rows: 2
                }}
              />
            </Col>
            <Col
              span={6}
              style={{
                paddingTop: '10px',
                paddingBottom: '10px',
                paddingLeft: '10px',
                paddingRight: '10px',
                height: '100%',
                width: '100%'
              }}
            >
              <Skeleton
                active
                paragraph={{
                  rows: 2
                }}
              />
            </Col>
          </Row>
        )} */}
      </div>
      <div
        style={{
          padding: '10px 24px',
          paddingBottom: '50px'
        }}
      >
        <Space
          direction="horizontal"
          style={{ width: '100%', marginBottom: '10px', justifyContent: 'space-between' }}
        >
          <Space>
            {isLeadAllowed ? (
              <Popover
                placement="bottomLeft"
                content={
                  <EbzFilterGroup
                    searchParams={searchArr}
                    filters={filtersArr}
                    apply={applyFiltersCallbackfunc}
                    clear={clearFiltersCallBackfun}
                  />
                }
                trigger="click"
                overlayStyle={{
                  width: '400px'
                }}
                overlayClassName="ebz-filters-popover"
              >
                <EbzButton
                  size="large"
                  onClick={() => {
                    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
                      name: 'search & filter'
                    });
                  }}
                  className="ebz-filters-btn"
                >
                  Search & Filter <DownOutlined />
                </EbzButton>
              </Popover>
            ) : (
              <Button type="primary" size="large" disabled>
                Search & Filter <DownOutlined />
              </Button>
            )}
          </Space>
          <Space size={10}>
            {loading || !isLeadAllowed || !canExportLead ? (
              <Button disabled icon={<ExportIcon />} size="large" className="export-btn">
                Export
              </Button>
            ) : (
              <EbzButton
                disabled={loading}
                icon={<ExportIcon />}
                size="large"
                onClick={() => {
                  leadDownloadableReport();
                  trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
                    name: 'Lead Download Report - Export'
                  });
                }}
                className="export-btn"
              >
                Export
              </EbzButton>
            )}
            {isLeadAllowed && canCreateLead ? (
              <Link to="/leads/create">
                <Button
                  icon={<PlusOutlined />}
                  type="primary"
                  size="large"
                  onClick={() => {
                    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
                      name: 'Create Lead'
                    });
                  }}
                  style={{ boxShadow: '0px 3px 6px #0000000f' }}
                  className="create-lead"
                  disabled={!canCreateLead}
                >
                  Create Lead
                </Button>
              </Link>
            ) : (
              <Button
                icon={<PlusOutlined />}
                type="primary"
                size="large"
                onClick={togglePlanModal}
                style={{ boxShadow: '0px 3px 6px #0000000f' }}
                className="create-lead"
                disabled
              >
                Create Lead
              </Button>
            )}
          </Space>
        </Space>
        {isLeadAllowed ? (
          <EbzTable
            columns={columns}
            // eslint-disable-next-line no-underscore-dangle
            rowKey={(r) => `${r._id}_lead`}
            dataSource={hasData ? data.leads : []}
            loading={loading}
            pagination={tableParams.pagination}
            onChange={handleTableChange}
            size="middle"
          />
        ) : (
          ''
        )}
      </div>
      {contextHolder}
    </>
  );
}

export default LeadsListPage;
